<template>
  <div class="text-body-2 text-textLight">
    <span class="text-textDarkest">{{ wordCount }}</span>
    word{{ wordCount > 1 ? 's' : '' }}
  </div>
</template>

<script>
export default {
  name: 'WordCount',
  props: {
    wordCount: { type: Number, default: 0 },
  },
};
</script>
